import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
  children: PropTypes.node
};

export default function InlineWrapper(props) {
  const { children } = props;

  return <div className="rec-form-inline-item-wrap">{children}</div>;
}

InlineWrapper.propTypes = propTypes;
